<button [disabled]="disabled" class="btn" [ngClass]="[typeClass, sizeClass]" (click)="onClick()">{{text}}</button>